import React from 'react';
import { Modal as CompassModal, Button } from '@ab-inbev-maz/compass';
import useModalStore, { hideGlobalModal } from '../stores/modalStore';
import ModalIcon from './ModalIcon';

const GlobalModal: React.FC = () => {
  const {
    isOpen,
    title,
    message,
    iconType,
    iconName,
    customIconSvg,
    primaryAction,
    secondaryAction,
    maxWidth,
  } = useModalStore();

  if (!isOpen) {
    return null;
  }

  return (
    <CompassModal open={isOpen} onClose={hideGlobalModal}>
      <div className={`flex flex-col gap-4 py-8 px-8 bg-white rounded-xl shadow-lg ${maxWidth || 'max-w-lg'} w-full mx-auto`}>
        {(iconType || customIconSvg) && (
          <ModalIcon type={iconType} iconName={iconName} />
        )}
        {title && (
          <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
        )}
        {message && (
          <div className="text-base font-normal text-gray-600">
            {typeof message === 'string' ? <p>{message}</p> : message}
          </div>
        )}
        {(primaryAction || secondaryAction) && (
          <div className="flex flex-col sm:flex-row gap-3 mt-4 w-full">
            {secondaryAction && (
              <Button
                className="w-full"
                variant={secondaryAction.variant || 'secondary'}
                size={secondaryAction.size || 'md'}
                onClick={() => {
                  secondaryAction.onClick();
                  hideGlobalModal();
                }}
                disabled={secondaryAction.disabled}
              >
                {secondaryAction.label}
              </Button>
            )}
            {primaryAction && (
              <Button
                className="w-full"
                variant={primaryAction.variant || 'primary'}
                size={primaryAction.size || 'md'}
                onClick={() => {
                  primaryAction.onClick();
                  hideGlobalModal(); 
                }}
                disabled={primaryAction.disabled}
              >
                {primaryAction.label}
              </Button>
            )}
          </div>
        )}
         {!primaryAction && !secondaryAction && (
            <div className="flex justify-center mt-4 w-full">
                 <Button
                    className="w-1/2"
                    variant='primary'
                    size='md'
                    onClick={hideGlobalModal}
                    >
                    Aceptar
                </Button>
            </div>
        )}
      </div>
    </CompassModal>
  );
};

export default GlobalModal;
